export default class SiteInactiveError extends Error {
}
